module.exports = __webpack_public_path__ + "img/ff-creator.359d593b.jpg";